(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function tryOpenUserlinkChat() {
      if (window.userlink && typeof window.userlink.setChatVisible === 'function') {
        window.userlink.setChatVisible(true);
        return true;
      }
      if (typeof window.setUserlinkChatVisible === 'function') {
        window.setUserlinkChatVisible(true);
        return true;
      }
      if (window.userlink && typeof window.userlink.openWithMessage === 'function') {
        window.userlink.openWithMessage('');
        return true;
      }
      var bubble = document.getElementById('userlink-chat-bubble') || document.getElementById('userlink-chat-bubble-container');
      if (bubble && typeof bubble.click === 'function') {
        bubble.click();
        return true;
      }
      return false;
    }

    function openSupportChat() {
      if (tryOpenUserlinkChat()) return;
      var attempts = 0, maxAttempts = 20, t = setInterval(function () {
        attempts++;
        if (tryOpenUserlinkChat() || attempts >= maxAttempts) clearInterval(t);
      }, 200);
    }

    function initSupportChatTriggers() {
      document.querySelectorAll('.support-chat-trigger').forEach(function (btn) {
        if (btn.dataset.chatInit === 'true') return;
        btn.dataset.chatInit = 'true';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openSupportChat();
        });
      });
    }

    initSupportChatTriggers();
    document.addEventListener('DOMContentLoaded', initSupportChatTriggers);
  })();

  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
